import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-icon-action-button',
  standalone: true,
  imports: [CommonModule, NgbTooltipModule],
  templateUrl: './icon-action-button.component.html',
  styleUrl: './icon-action-button.component.scss',
})
export class IconActionButtonComponent {
  @Input({ required: true }) icon!: string;
  @Input() shape: 'square' | 'circle' = 'square';
  @Input() tone: 'brand' | 'danger' | 'neutral' = 'brand';
  @Input() tooltip: string | null = null;
  @Input() ariaLabel = '';
  @Input() title = '';
  @Input() decorative = false;

  @Output() clicked = new EventEmitter<MouseEvent>();

  onClick(event: MouseEvent): void {
    event.stopPropagation();
    this.clicked.emit(event);
  }
}
